// extracted by mini-css-extract-plugin
export default {"characteristicItemWrapper":"characteristic-item_characteristicItemWrapper__xIoem","details":"characteristic-item_details__fV--M"};